import { Space } from 'antd';
import type { CSSProperties, ReactNode } from 'react';

export interface PageContainerProps {
  /** ページコンテンツ */
  children: ReactNode;
  /** 要素間の垂直スペース（デフォルト: 24） */
  gap?: number;
  /** 追加スタイル */
  style?: CSSProperties;
}

/**
 * 統一されたページコンテナコンポーネント
 *
 * MainLayout からのパディングを使用するため、追加パディングは不要。
 * Space direction="vertical" でコンテンツを垂直に配置。
 *
 * @example
 * ```tsx
 * <PageContainer>
 *   <PageHeader title="設備管理" subtitle="設備の一覧と管理" />
 *   <Card>...</Card>
 * </PageContainer>
 * ```
 */
export function PageContainer({
  children,
  gap = 24,
  style,
}: PageContainerProps): JSX.Element {
  return (
    <Space direction="vertical" size={gap} style={{ width: '100%', ...style }}>
      {children}
    </Space>
  );
}
